<template lang="html">

<div>

  <div class="inner-page">
       <!-- <div v-if="errorType==3" class="err-text">
            <div>请在微信浏览器内打开本应用</div>
            <div>We are now only support Wechat browser</div>
       </div> -->
       <div v-if="errorType==3" class="err-text">
            <div>请在手机浏览器内打开本应用</div>
            <div>We are now only support mobile browser</div>
       </div>
       <div v-else class="err-text">
             <div v-if="errorType==1">您的账户未授权，请联系所在机构</div>
             <div v-if="errorType==2">未关注公众号</div>
             <div>You are not allowed to set in , please check your authority first</div>
       </div>
  </div>

</div>

</template>

<script>
export default {
     data(){
          return{
              errorType:'',
              appH:''
          }
     },
     created:function(){
          this.errorType = this.$route.query.type;
          this.appH = document.documentElement.clientHeight;
     }
}
</script>

<style lang="css" scoped>

    .inner-page{
        position: fixed;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        overflow: hidden;
    }

    .err-text{
        font-size: 15px;
        text-align: center;
        flex-grow: 1;
        /* margin-top: -60px; */
        line-height: 24px;
        color: #666666;
    }

</style>
